export function getSVGRect (coord1, coord2) {
  const point1 = [[coord1.x, coord1.y], [coord2.x, coord1.y], [coord2.x, coord2.y], [coord1.x, coord2.y]]
  const result = point1.map((point) => {
    if (point.includes(null)) return false
    return point.join(',')
  })
  if (result.includes(false)) return ''
  return result.join(' ')
}

export function getViewBox (width, height) {
  if (width == null || height == null) return null
  const viewbox = [0, 0, width, height]
  return (viewbox.join(' '))
}

export default {
  getSVGRect: getSVGRect,
  getViewBox: getViewBox
}
